import React from 'react'
import { MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt, faEdit } from '@fortawesome/free-solid-svg-icons'
import HeaderTabla from '../componentes/HeaderTabla'
import BotonesFormulario from '../componentes/BotonesFormulario'
import moment from 'moment'

const VerInteracciones = ({ data, seleccionaRegistro }) => {

	const FormateaFecha = (dato) => {
		let fecha = moment(dato).format('YYYY-MM-DD')
		return fecha
	}

	const formatoSeparador = (number) => {
		const exp = /(\d)(?=(\d{3})+(?!\d))/g;
		const rep = '$1,';
		return `$${number.toString().replace(exp, rep)}`;
	}


	return (
		<div>
			<MDBTable hover responsive>
				<HeaderTabla array={['Estado', 'Fecha', 'Usuario', 'Nota', '']} />
				<MDBTableBody>

					{data.map((item, index) => {
						return (
							<tr key={index}>
								<td><div className={`estados`} style={{ backgroundColor: item.estado_color }}>{item.estado_crm}</div></td>
								<td>{FormateaFecha(item.fecha)}</td>
								<td>{item.usuario}</td>
								<td>{item.nota}</td>
								{/* <td style={{ wordWrap: 'break-word' }}>{item.usuario}</td>
								<td>{formatoSeparador(item.total_pedidos)}</td> */}
								<td className="tabla_funciones">
									<BotonesFormulario SeleccionarCategoria={seleccionaRegistro} editar={false} item={item} Roll={'Admin'} />
								</td>
							</tr>
						)

					})}

				</MDBTableBody>
			</MDBTable>
		</div>
	)
}

export default VerInteracciones